<template>
  <div class="planet-content">
    <img
      class="bg"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/planet-record-home-banner"
      alt=""
    />
    <div
      class="app-top"
      v-if="tabBarHeight"
      :style="{ background: 'rgba(255,255,255,' + tabOpacity + ')' }"
    >
      <div class="status-bar" :style="{ height: statusBarHeight + 'px' }"></div>
      <div class="app-tabbar" :style="{ height: tabBarHeight + 'px' }">
        <div class="title">{{ title }}</div>
        <div class="back iconfont icon-fanhui" @click="bindBack"></div>
      </div>
    </div>
    <div class="planet-position" @scroll="bindScroll">
      <div class="user-info" v-if="userInfo">
        <img class="avatar" :src="userInfo.head_img" alt="" />
        <div class="user-r">
          <div class="nickname">{{ userInfo.truename }}</div>
          <div class="desc">
            入驻betterWE第{{ userInfo.create_time | filterTime }}天
          </div>
        </div>
      </div>
      <!-- 我的bmi -->
      <div class="c-item bmi-content" v-if="bmiData" @click="jumpDetail('bmi')">
        <div class="bmi-box">
          <div class="bmi-flex">
            <div class="flex-l">
              <div class="text">我的BMI指数</div>
              <div class="bmi-text-flex">
                <span class="text1" v-if="bmiData.bmiStatus == 0"
                  >您的BMI指数已低于</span
                >
                <span class="text1" v-if="bmiData.bmiStatus == 1"
                  >您的BMI和</span
                >
                <span class="text1" v-if="bmiData.bmiStatus >= 2"
                  >您的BMI指数已超过</span
                >
                <span class="text2">成年人标准值</span>
                <span class="iconfont icon-wenhao"></span>
                <span class="text1" v-if="bmiData.bmiStatus == 1">持平</span>
              </div>
            </div>
            <div>
              <div class="num-content">
                <span
                  class="bmi-num"
                  :class="{ red: bmiData.bmiStatus != 1 }"
                  >{{ bmiData.bmi }}</span
                ><span class="radius-icon iconfont icon-you"></span>
              </div>
              <div
                class="status"
                :class="{ 'red-status': bmiData.bmiStatus != 1 }"
              >
                {{ bmiData.statusName }}
              </div>
            </div>
          </div>
          <div class="risk">
            <div class="risk-title" v-if="bmiData.bmiStatus != 1">
              <span class="iconfont icon-weixianyuan"></span
              ><span>风险提示</span>
            </div>
            <div class="title" v-else>可持续优化</div>
            <div class="risk-list" v-if="bmiData.warningLab">
              <div
                class="risk-item"
                v-for="(item, index) in bmiData.warningLab"
                :key="index"
              >
                {{ item }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <BannerText class="banner-text" :data="bannerList"></BannerText>
      <!-- 我的体重 -->
      <div
        class="c-item my-weight"
        @click="jumpDetail('weight')"
        v-if="weightData"
      >
        <div class="c-top">
          <div class="flex-1">
            <div>
              <span class="c-title">我的体重</span
              ><span class="c-unit">单位：KG</span>
            </div>
            <div class="c-time">{{ curWeightTime }}</div>
          </div>
          <div class="weight-c" v-if="weightData.change.weight">
            <span class="weight-num">{{ weightData.change.weight }}</span>
            <span class="radius-icon iconfont icon-you"></span>
          </div>
        </div>
        <div class="c-center" v-if="weightData">
          <div class="c-center-item">
            <div class="c-text">上次体重</div>
            <div class="c-unit-num">
              {{ weightData.change.last_data_value | filterNum }}
            </div>
          </div>
          <div class="c-center-item">
            <div class="c-text">目标体重</div>
            <div class="c-unit-num">
              {{ weightData.target_weight | filterNum }}
            </div>
          </div>
          <div class="c-center-item">
            <div class="c-text">我的最新变化</div>
            <div class="c-unit-num">
              <span class="my-change" v-if="weightData.change.trend_value"
                >{{ weightData.change.trend == 1 ? '+' : '-'
                }}{{ weightData.change.trend_value }}</span
              >
              <span v-else>-</span>
              <span
                v-if="weightData.change.trend_value"
                class="change-icon iconfont icon-xingzhuangjiehebeifen"
                :class="{ up: weightData.change.trend == 1 }"
              ></span>
            </div>
          </div>
        </div>
        <!-- 折线图 -->
        <div class="weight-data" v-if="weightData">
          <div class="not-data" v-if="!weightLength">
            <div class="text1">30天内无体重记录</div>
            <div class="text2">瘦身，从学会观察自我变化曲线开始</div>
          </div>
          <line-canvas
            v-if="weightCanvasData"
            :options="weightCanvasData"
          ></line-canvas>
        </div>
        <div class="add-btn">
          <span class="iconfont icon-jiahao"></span><span>记录体重</span>
        </div>
        <div class="tips-content"
          ><span class="red">*</span><span>为了让营养师提供更全面的服务</span
          ><br />
          <span>营期用户请前往</span><span class="red">“营期体测”</span
          ><span>进行数据记录</span>
        </div>
      </div>
      <!-- 我的围度 -->
      <div
        class="c-item my-waist"
        v-if="waistData"
        @click="jumpDetail('waist')"
      >
        <div class="c-top">
          <div class="c-title">我的围度</div>
          <div class="c-unit">单位：CM</div>
        </div>
        <div class="c-center">
          <div class="c-center-item">
            <div class="icon-item iconfont icon-yaowei"></div>
            <div class="c-line">
              <div class="c-text">腰围</div>
              <div class="c-unit-num">
                {{ waistData.waist_trend_value.change.waist | filterNum }}
              </div>
              <div
                class="c-change"
                v-if="waistData.waist_trend_value.change.trend_value"
              >
                <span>{{
                  waistData.waist_trend_value.change.trend == 1 ? '+' : '-'
                }}</span
                >{{ waistData.waist_trend_value.change.trend_value }}cm
              </div>
            </div>
          </div>
          <div class="c-center-item">
            <div class="icon-item iconfont icon-xiongwei"></div>
            <div class="c-line">
              <div class="c-text">胸围</div>
              <div class="c-unit-num">
                {{ waistData.bust_trend_value.change.bust | filterNum }}
              </div>
              <div
                class="c-change"
                v-if="waistData.bust_trend_value.change.trend_value"
              >
                <span>{{
                  waistData.bust_trend_value.change.trend == 1 ? '+' : '-'
                }}</span
                >{{ waistData.bust_trend_value.change.trend_value }}cm
              </div>
            </div>
          </div>
          <div class="c-center-item">
            <div class="icon-item iconfont icon-tunwei"></div>
            <div>
              <div class="c-text">臀围</div>
              <div class="c-unit-num">
                {{ waistData.hip_trend_value.change.hip | filterNum }}
              </div>
              <div
                class="c-change"
                v-if="waistData.hip_trend_value.change.trend_value"
              >
                <span>{{
                  waistData.hip_trend_value.change.trend == 1 ? '+' : '-'
                }}</span
                >{{ waistData.hip_trend_value.change.trend_value }}cm
              </div>
            </div>
          </div>
        </div>
        <div class="add-btn">
          <span class="iconfont icon-jiahao"></span><span>记录围度</span>
        </div>
      </div>
    </div>
    <van-loading
      class="v-loading"
      v-if="!loaded"
      text-color="#161617"
      color="#161617"
      vertical
      >加载中...</van-loading
    >
  </div>
</template>
<script>
import lineCanvas from './components/line-canvas/line-canvas.vue'
import { weightOptions } from './components/line-canvas/data'
import BannerText from './components/detail-components/banner-text.vue'
export default {
  components: {
    lineCanvas,
    BannerText
  },
  data() {
    return {
      disabledScroll: false,
      title: '我的档案',
      bannerList: [],
      tabBarHeight: 0, //顶部导航高度
      statusBarHeight: 0,
      tabOpacity: 0, //tab背景色透明度
      loaded: false,
      bmiData: null,
      hasWeight: true,
      waistData: null,
      userInfo: null,
      weightOptions: weightOptions,
      weightCanvasData: null,
      weightData: null,
      weightLength: 0,
      curWeightTime: ''
    }
  },
  filters: {
    filterNum(str) {
      if (!str) {
        return '-'
      }
      return str
    },
    filterTime(time) {
      time = time.replace(/-/g, '/')
      let cur = new Date().getTime()
      let start = new Date(time).getTime()
      let times = cur - start
      let day = times / 1000 / 60 / 60 / 24
      day = Math.floor(day + 1)
      return day
    }
  },
  created() {
    this.getTabBar()
    this.getUserInfo()
    this.getBmi()
    this.getWaist()
  },
  mounted() {
    this.getBannerList()
    this.getWeight()
    this.bindUMA()
  },
  methods: {
    //获取资源位列表
    getBannerList() {
      let params = {
        position_type: '4', //位置类型
        resource_type: '3' //资源位类型
      }
      this.$http
        .getAdvData(
          'member/ResourceLocation/getShowResourceLocationNew',
          params
        )
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            this.bannerList = res.data
          }
        })
        .catch((err) => {})
    },
    //埋点
    bindUMA() {
      this.$http.bindUMA('BG_DA_TZ', {})
      this.$http.bindUMA('BG_DZ_WD', {})
    },
    bindScroll(e) {
      let height = 150
      let target = e.target
      let scrollTop = target.scrollTop
      if (scrollTop >= height) {
        if (this.disabledScroll) {
          return
        }
        this.tabOpacity = 1
        this.disabledScroll = true
      } else {
        this.disabledScroll = false
        this.tabOpacity = parseFloat((scrollTop / height).toFixed(2))
      }
    },
    bindBack() {
      if (this.$http._isApp()) {
        this.$betterwe.onWebViewBack()
      } else {
        this.$router.go(-1)
      }
    },
    async getTabBar() {
      let res = await this.$betterwe.getAppBarHeight().catch(() => {})
      if (res) {
        this.tabBarHeight = res.toolsBarHeight
        this.statusBarHeight = res.statusBarHeight
      }
    },
    jumpDetail(curField) {
      this.$router.push({
        path: '/planet-record/detail',
        query: {
          curField: curField
        }
      })
    },
    getWeight() {
      let params = {
        time_type: 'day',
        time_length: 7
      }
      this.$http
        .getApp('member/UserBodyData/getUserBodyDataWeightTrend', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.weightOptions.xAxis.data = this.dealDayData(
              res.data.trend
            ).xList
            this.weightOptions.series[0].data = this.dealDayData(
              res.data.trend
            ).yList
            res.data.weight_trend_value.change.last_data_value = this.toFiexed1(
              res.data.weight_trend_value.change.last_data_value
            )
            res.data.weight_trend_value.change.trend_value = this.toFiexed1(
              res.data.weight_trend_value.change.trend_value
            )
            res.data.weight_trend_value.change.weight = this.toFiexed1(
              res.data.weight_trend_value.change.weight
            )
            res.data.weight_trend_value.change.init_weight = this.toFiexed1(
              res.data.weight_trend_value.change.init_weight
            )
            this.weightData = res.data.weight_trend_value
            this.weightLength = res.data.trend.length
            this.$nextTick(() => {
              this.weightCanvasData = this.weightOptions
            })
            let curWeightTime =
              (res.data.trend.length &&
                res.data.trend[res.data.trend.length - 1].day) ||
              ''
            this.curWeightTime = this.dealWeightDay(curWeightTime)
          }
        })
        .catch(() => {})
    },
    //保留一位小数
    toFiexed1(num) {
      if (num === null || num === undefined || num === '') {
        return ''
      }
      return (Math.round(num * 10) / 10).toFixed(1)
    },
    dealDayData(arr) {
      let xList = []
      let yList = []
      arr.map((item) => {
        xList.push(this.formatDay(item.day))
        yList.push(this.toFiexed1(item.weight))
      })
      if (arr.length < 7) {
        let len = 7 - arr.length
        for (let i = 0; i < len; i++) {
          xList.push('')
          yList.push(null)
        }
      }
      let res = {
        xList,
        yList
      }
      return res
    },
    dealWeightDay(str) {
      if (!str) {
        return str
      }
      let arr = str.split('-')
      return arr[0] + '年' + parseInt(arr[1]) + '月' + parseInt(arr[2]) + '日'
    },
    //处理天数显示方式
    formatDay(str) {
      let res
      str = str.replace(/-/g, '/')
      let difference = new Date().getTime() - new Date(str).getTime()
      let isToday = difference >= 0 && difference <= 1000 * 60 * 60 * 24
      if (isToday) {
        res = '今日'
      } else {
        let arr = str.split('/')
        res = arr[1] + '/' + arr[2]
      }
      return res
    },
    getUserInfo() {
      this.$http
        .getApp('member/UserBodyData/getUserInfoPlanetaryArchives', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.userInfo = res.data
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loaded = true
        })
    },
    //获取bmi数据
    getBmi() {
      this.$http
        .getApp('member/UserBodyData/getUserBmiExplain', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            res.data.bmiStatus = this.computeBmi(res.data.bmi)
            this.bmiData = res.data
          }
        })
        .catch(() => {})
    },
    computeBmi(bmi) {
      let index
      let arr = [
        {
          min: -Infinity,
          max: 18.5
        },
        {
          min: 18.5,
          max: 24
        },
        {
          min: 24,
          max: 28
        },
        {
          min: 28,
          max: Infinity
        }
      ]
      for (let i = 0; i < arr.length; i++) {
        if (bmi > arr[i].min && bmi <= arr[i].max) {
          index = i
          break
        }
      }
      return index
    },
    //获取围度
    getWaist() {
      this.$http
        .getApp('member/UserBodyData/getUserDimension', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.waistData = res.data
          }
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.planet-content {
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: #f7f7f7;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .planet-position {
    width: 100%;
    box-sizing: border-box;
    position: relative;
    flex: 1;
    flex-shrink: 0;
    overflow-y: scroll;
  }

  .bg {
    width: 100%;
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
  }

  .user-info {
    padding-left: 40px;
    display: flex;
    align-items: center;
    margin-top: 24px;
    margin-bottom: 16px;

    .avatar {
      object-fit: cover;
      width: 44px;
      height: 44px;
      background-color: #fff;
      border-radius: 50%;
      margin-right: 12px;
    }

    .user-r {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;

      .nickname {
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 25px;
        margin-bottom: 2px;
      }

      .desc {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.5);
        line-height: 17px;
      }
    }
  }

  .bmi-content {
    position: relative;
    text-align: center;
    padding: 20px 0px 18px;
    margin-top: 20px;
    margin-bottom: 16px;

    .bmi-box {
      background: #ffffff;
      border-radius: 12px;
      padding: 0px 20px;
      box-sizing: border-box;
      text-align: left;

      .bmi-flex {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .flex-l {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;

          .bmi-text-flex {
            display: flex;
            align-items: center;
          }

          .iconfont {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #6236ff;
            font-size: 14px;
          }
        }

        .text {
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #000000;
          line-height: 22px;
          margin-bottom: 8px;
        }

        .text1 {
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.8);
          line-height: 14px;
          margin-left: 2px;
          margin-right: 8px;
        }

        .text2 {
          font-size: 10px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #6236ff;
          line-height: 14px;
          margin-right: 4px;
        }
      }

      .bmi-num {
        font-size: 32px;
        height: 32px;
        line-height: 38px;
        font-family: DINCondensed-Bold;
        font-weight: bold;
        margin-right: 15px;
        color: #2eb257;
      }

      .red {
        color: #ff2b48;
      }

      .green {
        color: #2eb257;
      }

      .num-content {
        display: flex;
        align-items: center;
        /* margin-bottom: 8px; */
      }

      .status {
        padding: 0px 8px 0px 12px;
        text-align: center;
        letter-spacing: 4px;
        height: 17px;
        line-height: 17px;
        background: #2eb257;
        border-radius: 6px;
        font-size: 10px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        display: inline-block;
      }

      .red-status {
        background-color: #ff2b48;
      }

      .risk {
        background: #f7f7f7;
        border-radius: 8px;
        padding: 12px 14px;

        .risk-title {
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ff2b48;
          line-height: 17px;

          .iconfont {
            font-size: 12px;
            color: #ff6379;
            margin-right: 8px;
          }
        }

        .title {
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #000000;
          line-height: 17px;
        }

        .risk-list {
          display: flex;
          flex-wrap: wrap;
          align-items: center;

          .risk-item {
            white-space: nowrap;
            height: 22px;
            line-height: 22px;
            background: #ffffff;
            border-radius: 4px;
            padding: 0px 15px;
            margin: 3px;
            font-size: 10px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #000000;
          }
        }
      }
    }
  }

  .c-item {
    background: #ffffff;
    border-radius: 12px;
    padding: 15px 0px 20px;
    box-sizing: border-box;
    width: 335px;
    margin: 0 auto;
    margin-bottom: 16px;

    .c-top {
      display: flex;
      align-items: center;
      margin-bottom: 14px;
      padding: 0px 20px;
      box-sizing: border-box;

      .c-title {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 22px;
      }

      .c-unit {
        flex: 1;
        flex-shrink: 0;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.5);
        line-height: 12px;
        margin-left: 10px;
        margin-right: 10px;
      }

      .c-btn {
        height: 25px;
        line-height: 25px;
        padding: 0px 12px;
        background: #ffffff;
        border-radius: 10px;
        border: 2px solid #6236ff;
        font-size: 13px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #6236ff;
      }
    }

    .c-center {
      display: flex;
      //padding: 0px 14px;
      box-sizing: border-box;
      text-align: center;

      .c-center-item {
        width: 33.33%;
      }

      .c-line {
        border-right: 1px solid #efefef;
      }

      .c-text {
        white-space: nowrap;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.7);
        line-height: 17px;
        margin-bottom: 10px;
      }

      .c-unit-num {
        white-space: nowrap;
        font-size: 24px;
        font-family: DINCondensed-Bold, DINCondensed;
        font-weight: bold;
        color: #000000;
        height: 24px;
        line-height: 20px;
      }

      .c-change {
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #6236ff;
        line-height: 17px;
      }

      .icon-item {
        margin-bottom: 10px;
        color: #000;
        font-size: 32px;
      }

      .gray-content {
        margin: 0 auto;
        width: 296px;
        background: #f7f7f7;
        border-radius: 8px;
        display: flex;
        padding: 10px 0px;
        align-items: center;
        margin-bottom: 12px;

        .c-center-item {
          flex: 1;
        }

        .line {
          width: 2px;
          height: 39px;
          background-color: #ebebeb;
        }
      }
    }
  }

  .my-weight {
    .weight-data {
      position: relative;
      padding: 0px 10px;
      box-sizing: border-box;
      height: 104px;
      /*  margin-top: 20px; */
    }

    .set-weight {
      font-size: 12px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #6236ff;
      line-height: 38px;
    }

    .flex-1 {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;

      .c-time {
        font-size: 10px;
        margin-top: 3px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.8);
        line-height: 14px;
      }
    }

    .weight-c {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 38px;
    }

    .weight-num {
      height: 32px;
      margin-right: 13px;
      font-size: 32px;
      font-family: DINCondensed-Bold, DINCondensed;
      font-weight: 600;
      color: #000000;
      line-height: 38px;
    }

    .icon-black {
      display: inline-block;
      width: 16px;
      height: 16px;
      background: #ffffff;
      border-radius: 50%;
      overflow: hidden;
      border: 1px solid #f1f1f1;
      font-size: 12px;
      color: #999;
      text-align: center;
      line-height: 16px;
    }

    .icon-xingzhuangjiehebeifen {
      display: inline-block;
      font-size: 10px;
      color: rgba(53, 199, 99, 1);
    }

    .change-icon {
      color: rgba(53, 199, 99, 1);
    }

    .up {
      color: #ff2b48;
      transform: rotate(180deg);
      transform-origin: center;
    }

    .down {
      color: rgba(53, 199, 99, 1);
    }

    .my-change {
      margin-right: 8px;
    }
  }

  .my-waist {
    .icon-list {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .icon-item {
        flex: 1;
        text-align: center;
      }
    }
  }

  .not-data {
    text-align: center;
    width: 100%;
    left: 0;
    transform: translate(0%, -50%);
    position: absolute;
    top: 38%;
    z-index: 10;

    .text1 {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #000000;
      line-height: 20px;
    }

    .text2 {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.3);
      line-height: 17px;
    }
  }

  .add-btn {
    text-align: center;
    width: 232px;
    height: 32px;
    margin: 0 auto;
    margin-top: 16px;
    background: #6236ff;
    border-radius: 12px;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;

    .iconfont {
      font-size: 14px;
      margin-right: 10px;
    }
  }

  .tips-content {
    margin: 16px auto 0px;
    width: 295px;
    box-sizing: border-box;
    background: #f8f5ff;
    border-radius: 10px;
    padding: 8px 11px 10px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.8);
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 22px;
    text-align: center;

    .red {
      color: #e61f1f;
      font-size: 12px;
    }
  }
}

.app-tabbar {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  .title {
    text-align: center;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000;
  }

  .back {
    padding: 10px;
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translate(0%, -50%);
    font-size: 16px;
    font-weight: 600;
    color: #000;
  }
}

.app-top {
  width: 100%;
  background-color: #fff;
  z-index: 10;
}

.status-bar {
  width: 100%;
}

.v-loading {
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%);
}

.radius-icon {
  width: 16px;
  height: 16px;
  background: #ffffff;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid #f1f1f1;
  font-size: 12px;
  color: #999;
  text-align: center;
  line-height: 16px;
}

.banner-text {
  margin-bottom: 14px;
}
</style>
